import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsIdeaObjectBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The idea object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the idea.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description:
                  'The number of child ideas (ideas that have this idea as their parent).',
                heading: 'childCount',
                subheading: 'number',
              },
              {
                description: 'The user who authored the idea, if any.',
                heading: 'author',
                subheading: 'User object | null',
              },
              {
                description: 'Time at which the idea was created, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: 'The description of the idea.',
                heading: 'description',
                subheading: 'string',
              },
              {
                description: 'The group this idea belongs to, if any.',
                heading: 'group',
                subheading: 'Group object | null',
              },
              {
                description: 'The user who is assigned as owner of this idea, if any.',
                heading: 'owner',
                subheading: 'User object | null',
              },
              {
                description: 'The parent idea, if this idea is a child of another idea.',
                heading: 'parent',
                subheading: 'Partial idea object | null',
              },
              {
                description: 'The source where the idea was created from.',
                heading: 'source',
                subheading: 'Source object',
              },
              {
                description: 'The status of the idea.',
                heading: 'status',
                subheading: 'Status object',
              },
              {
                description: 'The title of the idea.',
                heading: 'title',
                subheading: 'string',
              },
              {
                description: 'Time at which the idea was last updated, in ISO 8601 format.',
                heading: 'updatedAt',
                subheading: 'string',
              },
              {
                description: 'The URL name of the idea.',
                heading: 'urlName',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example idea object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba1238",
  "author": {
    "id": "553c3ef8b8cdcd1501ba1236",
    "created": "${this.createdAt.toISOString()}",
    "email": "john@example.com",
    "isAdmin": false,
    "name": "John Doe",
    "url": "https://your-company.canny.io/admin/users/john-doe",
    "userID": "1234"
  },
  "childCount": 1,
  "created": "${this.createdAt.toISOString()}",
  "description": "Test idea description",
  "group": {
    "id": "553c3ef8b8cdcd1501ba1235",
    "name": "Feature Requests",
    "description": "Feature requests are ideas for new features or improvements to the product.",
    "urlName": "feature-requests"
  },
  "owner": {
    "id": "553c3ef8b8cdcd1501ba1236",
    "created": "${this.createdAt.toISOString()}",
    "email": "john@example.com",
    "isAdmin": false,
    "name": "John Doe",
    "url": "https://your-company.canny.io/admin/users/john-doe",
    "userID": "1234"
  },
  "parent": {
    "id": "553c3ef8b8cdcd1501ba1237",
    "title": "Parent Idea",
    "urlName": "parent-idea"
  },
  "source": {
    "name": "canny",
    "type": "web"
  },
  "status": {
    "id": "553c3ef8b8cdcd1501ba2234",
    "name": "Under Review",
    "type": "Active",
    "urlName": "under-review"
  },
  "title": "An awesome feature request",
  "updatedAt": "${this.createdAt.toISOString()}",
  "urlName": "an-awesome-feature-request"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
